import { useState, useEffect, useCallback } from 'preact/hooks';
import { sendRequest } from '../../../tools';

export const useFetchDevices = (url) => {
  const [devices, setDevices] = useState(null);
  const [unit, setUnit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!url) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await sendRequest(url + '&asJson=1', { showLoader: true });

      if (response.status === 200) {
        setDevices(response.data.devices);
        setUnit(response.data.unit);
        console.log(response.data);
      } else {
        throw new Error(`Status ${response.status}. Status text: ${response.statusText}`);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while fetching data');
      console.error('Error fetching devices:', err);
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { devices, unit, loading, error, refetch: fetchData };
};
